import { render, staticRenderFns } from "./wxback.vue?vue&type=template&id=5f9cac48&scoped=true&"
import script from "./wxback.vue?vue&type=script&lang=js&"
export * from "./wxback.vue?vue&type=script&lang=js&"
import style0 from "./wxback.vue?vue&type=style&index=0&id=5f9cac48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9cac48",
  null
  
)

export default component.exports